import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Cart = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M7.822 15.77A1.993 1.993 0 0 0 9.667 17h7.639c.828 0 1.581-.521 1.873-1.297l2.757-7.352A1.001 1.001 0 0 0 21 7H6.333l-1.41-3.385A1 1 0 0 0 4 3H2v2h1.333l4.489 10.77zM19.557 9l-2.25 6h-7.64l-2.5-6h12.39z", key: "k0" }),
        React.createElement("circle", { cx: 10.5, cy: 20.5, r: 1.5, key: "k1" }),
        React.createElement("circle", { cx: 16.438, cy: 20.5, r: 1.5, key: "k2" })));
});
Cart.displayName = 'Cart';
export var CartDimensions = { height: 24, width: 24 };
